import { useCallback, useMemo } from "react";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import type * as Model from "../../model";

type Props = {
	cityTagList: Model.Type.ViewData["cityTagList"];
	selectedCityTag?: string;
	onSelect: (cityTag: string) => void;
};

export const CitySelectField = ({ cityTagList, selectedCityTag, onSelect }: Props) => {
	/**
	 * 都市タグ選択時の処理
	 */
	const handleChangeCityTag = useCallback(
		(value: string) => {
			onSelect(value);
		},
		[onSelect],
	);

	const selectFieldOptions = useMemo(
		(): Array<FormOptionType> =>
			cityTagList.map((tag) => ({
				id: tag,
				value: tag,
				label: tag,
			})),
		[cityTagList],
	);

	return (
		<div className="space-y-1">
			<p>地域</p>
			<SelectField value={selectedCityTag} options={selectFieldOptions} handleValueChange={handleChangeCityTag} />
		</div>
	);
};
